/** Who has to act on a hold: a staff member or a service provider. */
export enum OwnerType {
  STAFF = 'STAFF',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
}
